import Cookies from 'js-cookie'

export class User {
     private static Userkey='user_token'

     static isLogin (): boolean {
       let isLogin = false
       if (this.get()) {
         isLogin = true
       }
       return isLogin
     }

     static get () {
       return Cookies.get(this.Userkey)
     }

     static set (value: string) {
       Cookies.set(this.Userkey, value)
     }
}
